<template>
  <div class="terms-page-container">
    <h1>{{ pageContent.title }}</h1>
    <p>{{ pageContent.lastUpdated }}</p>
    <p>{{ pageContent.description }}</p>

    <section
      v-for="section in pageContent.sections"
      :key="section.id"
      :id="section.id"
    >
      <h2>{{ section.title }}</h2>
      <template
        v-for="(paragraph, index) in section.paragraphs || []"
        :key="`${section.id}-paragraph-${index}`"
      >
        <p v-if="typeof paragraph === 'string'">
          {{ paragraph }}
        </p>
        <p v-else-if="paragraph.type === 'privacy'">
          <span>{{ paragraph.prefix }}</span>
          <RouterLink :to="paragraph.linkTo">{{ paragraph.linkLabel }}</RouterLink
          >{{ paragraph.suffix }}
        </p>
      </template>
    </section>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { RouterLink } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { termsOfServiceContent } from '@/content/termsOfService';

const { locale } = useI18n();
const pageContent = computed(
  () => termsOfServiceContent[locale.value] ?? termsOfServiceContent['en-US']
);
</script>

<style scoped>
.terms-page-container {
  max-width: 800px;
  margin: 20px auto;
  padding: 25px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  line-height: 1.7;
  color: #34495e; /* Darker grey for text */
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.terms-page-container h1 {
  text-align: center;
  margin-bottom: 15px;
  color: #2c3e50; /* Even darker for main title */
  font-size: 2em;
  font-weight: 600;
}
.terms-page-container p:first-of-type { /* For "Last updated date" */
  text-align: center;
  font-size: 0.9em;
  color: #7f8c8d; /* Lighter grey for meta text */
  margin-bottom: 25px;
}
.terms-page-container h2 {
  margin-top: 35px;
  margin-bottom: 18px;
  padding-bottom: 10px;
  border-bottom: 2px solid #ecf0f1; /* Lighter border */
  color: #16a085; /* Theme color for section titles */
  font-size: 1.6em;
  font-weight: 500;
}
.terms-page-container p {
  margin-bottom: 12px;
  text-align: justify;
  color: #34495e;
}
.terms-page-container section {
  margin-bottom: 25px;
}
.terms-page-container a {
  color: #2980b9; /* Standard link blue */
  text-decoration: none;
}
.terms-page-container a:hover {
  text-decoration: underline;
}
</style>
